import { Drawer, DrawerContent } from "@/components/ui/drawer";
import { Toaster } from "@/components/ui/sonner";
import { useHomePageStore } from "@/store";
import { cn } from "@roman/shared/utils";
import { useEffect, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { MyPage } from "../mypage";
import { BottomNavigationBar } from "./BottomNavigatorBar";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { Menu } from "./Menu";
const hiddenMenuPages = [
  "/login",
  "/register",
  "/profile/edit",
  //TODO: The topPage URL needs to be changed.
  "/top",
  "/referral/register",
];
const shownMobileNavigationBarPages = ["/", "my-entry"];

export const Layout = () => {
  const open = useHomePageStore((state) => state.isOpenMyPageSidebar);
  const setOpen = useHomePageStore((state) => state.setIsOpenMyPageSidebar);
  const location = useLocation();
  const pathname = location.pathname;

  const isShowMenuNavigationBarPC = useMemo(() => !hiddenMenuPages.includes(pathname), [pathname]);
  const isShowBottomNavigationBarMobile = useMemo(() => shownMobileNavigationBarPages.includes(pathname), [pathname]);

  const currentPath = useMemo(() => {
    return `${location.pathname}${location.search}`;
  }, [location]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: We have to use this because we want to scroll to top when the page changes.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPath]);

  return (
    <>
      <div className="min-h-screen flex flex-col">
        <Header />
        {!isShowMenuNavigationBarPC && <Outlet />}
        {isShowMenuNavigationBarPC && (
          <div className="flex-1 flex">
            <div
              className={cn(
                "relative w-full md:grid md:grid-cols-4 md:gap-1 lg:gap-3 md:pb-0",
                isShowBottomNavigationBarMobile && "pb-20",
              )}
            >
              <div className="hidden md:block">{isShowMenuNavigationBarPC && <Menu />}</div>
              <div
                className={cn(
                  !isShowBottomNavigationBarMobile && "min-h-screen",
                  pathname !== "/profile/edit" && pathname !== "/referral/register" && "md:col-span-3 xl:col-span-2",
                )}
              >
                <Outlet />
              </div>
            </div>
          </div>
        )}
        {isShowMenuNavigationBarPC && isShowBottomNavigationBarMobile && <BottomNavigationBar className="md:hidden" />}
        <Drawer direction="right" open={open} onClose={() => setOpen(false)} onOpenChange={(isOpen) => setOpen(isOpen)}>
          <DrawerContent
            className="h-screen top-0 right-0 left-auto mt-0 w-full sm:w-3/4 md:w-1/2 lg:w-2/5 2xl:w-1/4 rounded-none"
            dragClassName="hidden"
          >
            <MyPage />
          </DrawerContent>
        </Drawer>
        <Toaster />
        <Footer />
      </div>
    </>
  );
};
